import { Component } from '@angular/core';
import { AbstractInputComponent } from '../abstract-input.component';

import { MatError, MatFormField, MatHint, MatInput } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'logpn-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    ReactiveFormsModule,
    MatError,
    TranslocoPipe,
    MatHint
],
})
export class InputTextComponent extends AbstractInputComponent {}
